import { render, staticRenderFns } from "./EnableApiSettings.vue?vue&type=template&id=a54d653a"
import script from "./EnableApiSettings.vue?vue&type=script&lang=js"
export * from "./EnableApiSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports